import React, { useState, useEffect, useCallback } from 'react';
import './Testimonials.scss';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Rajesh Kumar",
      text: "I started using Discover mainly for the rolling ATM straddle view. Watching the live shift of ATM with candlestick confirmation changed how I trade intraday volatility. It feels like seeing the market think in real time.",
    },
    {
      name: "Amit Patel",
      text: "I trade weekly options and the dynamic ATM straddle on Discover helped me avoid random entries. Seeing how the straddle evolves candle by candle gave me confidence to stay disciplined.",
    },
    {
      name: "Deepak Verma",
      text: "What impressed me most is the advanced option chain. It is not cluttered like traditional chains. The way Greeks, OI, and price action come together makes patterns obvious instead of confusing.",
    },
    {
      name: "Sneha Reddy",
      text: "I manage three broker accounts. Earlier it was chaos switching platforms. With fnotrader, I manage all accounts from one dashboard and execute strategies consistently across them.",
    },
    {
      name: "Vikram Singh",
      text: "The options dashboard feels built by real traders. Strategy charts, leg level visibility, and clean execution controls make it far superior to anything I used before.",
    },
    {
      name: "Nikhil Gupta",
      text: "I use 1-click straddle and strangle execution daily. Speed matters in volatility trades and this terminal removes hesitation. One click and the structure is live. That simplicity is powerful.",
    },
    {
      name: "Priya Sharma",
      text: "The straddle and strangle charts are extremely clean. Earlier, I had to mentally combine legs from different screens. Now I see the combined P&L and behavior instantly. This alone improved my decision making.",
    },
    {
      name: "Karthik Iyer",
      text: "The rolling ATM straddle visualization helped me understand when volatility is expanding versus just noisy movement. That clarity alone reduced my overtrading.",
    },
    {
      name: "Aarav Desai",
      text: "I connected my TradingView signals to the algo engine and started running multiple strategies in parallel. Unlimited algo execution without per-strategy limits is a big advantage.",
    },
    {
      name: "Rohit Mehta",
      text: "What stood out is how Discover links analysis to execution. I analyze the market regime using charts and chains, then directly act using the terminal without context switching.",
    },
    {
      name: "Kunal Nair",
      text: "I turned consistently profitable after I stopped guessing and started reacting to structure. The straddle and strategy charts show structure clearly. My losses are smaller and wins more controlled now.",
    },
    {
      name: "Arjun Rao",
      text: "The candlestick charts combined with options data feel like a missing layer I never had before. I no longer trade options blindly without price context.",
    },
    {
      name: "Rahul Joshi",
      text: "As a short volatility trader, the dynamic ATM straddle view helped me time entries better. I now wait for confirmation instead of forcing trades.",
    },
    {
      name: "Sanjay Malhotra",
      text: "I run discretionary trades and algos together. The algo signals module lets me automate what is repeatable and manually execute what needs judgment. Both live in one ecosystem.",
    },
    {
      name: "Pranav Khanna",
      text: "The platform scales with you. I started with manual straddles, moved to structured strategies, and now run algos. The transition felt natural, not forced.",
    },
    {
      name: "Manish Agarwal",
      text: "I like how strategy charts show combined behavior instead of just individual legs. It gives a true picture of risk and reward while the trade is live.",
    },
    {
      name: "Varun Bhat",
      text: "Managing multiple client accounts used to be stressful. Now executions are uniform and risk stays consistent across accounts. That alone saves me hours every week.",
    },
    {
      name: "Suresh Menon",
      text: "The advanced option chain makes support and resistance visible through OI behavior. I no longer rely on guesswork or generic indicators.",
    },
    {
      name: "Aakash Kapoor",
      text: "I tested several execution platforms before. fnotrader feels purpose-built for serious options traders, not just adapted from equity terminals.",
    },
    {
      name: "Aditya Chopra",
      text: "This is the first platform where analysis, execution, and automation feel connected. From Discover to terminal to algo signals, everything flows logically. It genuinely upgraded my trading process.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      const wasMobile = isMobile;
      const nowMobile = window.innerWidth <= 640;
      setIsMobile(nowMobile);
      
      if (wasMobile !== nowMobile) {
        setCurrentIndex(0);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [isMobile]);
  
  const itemsPerSlide = isMobile ? 1 : 2;
  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => 
      prevIndex === totalSlides - 1 ? 0 : prevIndex + 1
    );
  }, [totalSlides]);

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? totalSlides - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlaying(false);
  };

  useEffect(() => {
    if (!isAutoPlaying) return;
    
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, [isAutoPlaying, nextSlide]);

  const renderStars = (rating = 5) => {
    return [...Array(rating)].map((_, i) => (
      <svg
        key={i}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
      </svg>
    ));
  };

  return (
    <section className="testimonials">
      <div className="container">
        <div className="header">
          <h2>Loved by traders from across India</h2>
          <p>Thousands of traders trust FNOTrader on a daily basis</p>
        </div>

        <div className="carousel-wrapper">
          <button 
            className="carousel-arrow carousel-arrow-left"
            onClick={prevSlide}
            aria-label="Previous testimonials"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>

          <div className="carousel-container">
            <div 
              className="carousel-track"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => {
                const slideTestimonials = testimonials.slice(
                  slideIndex * itemsPerSlide, 
                  (slideIndex + 1) * itemsPerSlide
                );
                
                return (
                  <div key={slideIndex} className="grid">
                    {slideTestimonials.map((testimonial, index) => (
                      <div key={`${slideIndex}-${index}`} className="testimonial-card">
                        <svg
                          className="quote-icon"
                          fill="currentColor"
                          viewBox="0 0 32 32"
                        >
                          <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"></path>
                        </svg>
                        <p className="testimonial-content">{testimonial.text}</p>
                        <div className="author">
                          <div className="avatar">
                            <span>{testimonial.name.charAt(0)}</span>
                          </div>
                          <div className="author-info">
                            <div className="name">{testimonial.name}</div>
                            <div className="stars">
                              {renderStars(5)}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          <button 
            className="carousel-arrow carousel-arrow-right"
            onClick={nextSlide}
            aria-label="Next testimonials"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>

        <div className="carousel-dots">
          {Array.from({ length: totalSlides }).map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;